// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 250;
  width: 100vw;
  height: 100vh;
  border: 2px red dashed;
  background: rgba(0,0,0, 0.25);
}
.modal-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.modal-container {
  width: 340px;
  padding: 35px 20px;
  display: flex;
  flex-direction: column;
  background: #FFF;
}
.modal-header {
  margin-bottom: 15px;
}
.modal-close {
  position: relative;
  right: 0;
  text-align: right;
}
.modal-body {
  margin-bottom: 30px;
}
.modal-footer .modal-default-button {
  width: 100%;
  padding-block: 15px;
  background: #000;
  color: #FFF;
  text-align: center;
  border: none;
  cursor: pointer;
}

`, "",{"version":3,"sources":["webpack://./src/webpack/vue/components/Modal.vue"],"names":[],"mappings":";AAoHA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AACA;AACA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACA;AACA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AACA;AACA;EACA,mBAAA;AACA;AACA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AACA;AACA;EACA,mBAAA;AACA;AACA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AACA","sourcesContent":["<template>\n  <transition name=\"modal\">\n    <div class=\"modal-mask\">\n      <div class=\"modal-wrapper\">\n        <div class=\"modal-container\">\n  \n          <div class=\"modal-close\">\n            <span @click=\"$emit('close')\">\n              <slot name=\"modal-close\">x</slot>\n            </span>\n          </div>\n          <div class=\"modal-header\">\n            <slot name=\"header\">\n              default header\n            </slot>\n          </div>\n  \n          <div class=\"modal-body\">\n            <slot name=\"body\">\n              default body\n            </slot>\n          </div>\n  \n          <div class=\"modal-footer\">\n            <div class=\"modal-default-button\" @click=\"donate()\">\n              <slot name=\"bottm-button\">\n                Button\n              </slot>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </transition>\n</template>\n<script>\n  const axios = require('axios').default;\n\n  export default {\n    name: 'Modal',\n    props:['variantid'],\n    data() {\n      return {  \n      }\n    },\n    methods: {\n      donate() {\n        // add donation product\n\t\t\t\tconst config = {\n\t\t\t\t\tmethod: 'post',\n\t\t\t\t\turl: '/cart/add.js',\n\t\t\t\t\tdata: {\n\t\t\t\t\t\tid: this.variantid,\n\t\t\t\t\t\tquantity: 1\n\t\t\t\t\t},\n\t\t\t\t};\n\t\t\t\taxios(config)\n\t\t\t\t.then(() => window.location.reload())\n\t\t\t\t.catch(err => console.error(err))\n      }\n    },\n    mounted() {\n      console.log('mounted')\n    }\n  };\n  </script>\n  \n  <style >\n    .modal-mask {\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      z-index: 250;\n      width: 100vw;\n      height: 100vh;\n      border: 2px red dashed;\n      background: rgba(0,0,0, 0.25);\n    }\n    .modal-wrapper {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n    .modal-container {\n      width: 340px;\n      padding: 35px 20px;\n      display: flex;\n      flex-direction: column;\n      background: #FFF;\n    }\n    .modal-header {\n      margin-bottom: 15px;\n    }\n    .modal-close {\n      position: relative;\n      right: 0;\n      text-align: right;\n    }\n    .modal-body {\n      margin-bottom: 30px;\n    }\n    .modal-footer .modal-default-button {\n      width: 100%;\n      padding-block: 15px;\n      background: #000;\n      color: #FFF;\n      text-align: center;\n      border: none;\n      cursor: pointer;\n    }\n    \n  </style>\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
